var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"flat":"","color":"white"}},[_c('v-toolbar-title',[_vm._v("Visualización de datos")]),_c('v-spacer'),_c('div',{attrs:{"id":"draw-shapes"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }